import { useEffect, useState } from "react";
import { comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid, CommonErrors } from "@/comn/components";
import { useGrid, usePage, useModal, useFetch } from "@/comn/hooks";
import { APIS, SG_GFS_EXCL_UPLD_RGSR } from "./services/OsciGfsMgmtService"; // 서비스
/*
 * GFS Code Excel Upload Registration
 * !== GFS 코드 엑셀 업로드 등록 ==!
 */
export const OSCI0406008S = () => {
    const { pgeUid, menuId } = usePage();
    const modal = useModal();
    const [gridDataList, setGridDataList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {};

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // GFS Excel Upload Registration !== GFS 엑셀 업로드 등록 ==!
        gfsExclUpldRgsr: useGrid({
            defaultSchema: SG_GFS_EXCL_UPLD_RGSR,
            page: 0,
            size: 10,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        saveGfsExclUpld: useFetch({
            api: (data) => APIS.saveGfsExclUpld(data),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onCancel: () => {
                        modal.postMessage("");
                    },
                });
            },
            onError: (error) => {
                console.log(error);

                const errList = error?.response?.data?.errList || [];

                if (errList.length > 0) {
                    modal.openModal({
                        content: <CommonErrors errors={errList} />,
                        draggable: true,
                        size: "lg",
                    });
                }
            },
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        saveGfsExclUpld: () => {
            const data = { gfsCdList: grid.gfsExclUpldRgsr.getData() };
            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    fetch.saveGfsExclUpld.fetch(data);
                },
            });
        },
    };

    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_GFS_CD_RGSR"} titleSize={2}></Group.Title>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role="tmplDown"
                                onClick={() => {
                                    grid.gfsExclUpldRgsr.downloadTemplate("2055f8c8-1cd3-dfe0-e063-030011acbe2d");
                                }}
                            ></Button>
                            <Button
                                role="excelUpload"
                                onClick={async () => {
                                    const data = await grid.gfsExclUpldRgsr.importExcel({
                                        headers: 0,
                                    });

                                    // 기존 데이터 추가 (기존 데이터를 지우지 않고 추가)
                                    grid.gfsExclUpldRgsr.setData(
                                        comnUtils.getGridData([...grid.gfsExclUpldRgsr.getData(), ...data]),
                                    );

                                    // 기존 데이터 대체 (기존 데이터를 지우고 새로 업로드)
                                    // grid.gfsExclUpldRgsr.setData(comnUtils.getGridData(data));
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="gridAdd"
                                onClick={() => {
                                    grid.gfsExclUpldRgsr.addRow();
                                }}
                            ></Button>
                            <Button
                                role="gridDelete"
                                onClick={() => {
                                    grid.gfsExclUpldRgsr.deleteRow("checkbox");
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                    <Grid {...grid.gfsExclUpldRgsr.grid} data={gridDataList} />
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            const result = grid.gfsExclUpldRgsr.validate();
                            if (result) {
                                modal.openModal({
                                    content: <CommonErrors {...result} />,
                                    draggable: true,
                                    size: "lg",
                                });
                            } else {
                                handler.saveGfsExclUpld();
                            }
                        }}
                    ></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
